var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_7946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 0H4.72925C3.78417 0 2.95435 0.777476 2.95435 1.69775V18.8639C2.95435 19.172 3.04008 19.4287 3.17826 19.6271C3.34351 19.8642 3.60958 20.0001 3.8949 20C4.16465 20 4.45186 19.8799 4.71708 19.6534L9.90881 15.2453C10.0692 15.1084 10.2995 15.0299 10.539 15.0299C10.7783 15.0299 11.0082 15.1084 11.169 15.2457L16.3434 19.6527C16.6096 19.8799 16.877 20.0001 17.1462 20.0001C17.6016 20.0001 18.0455 19.6488 18.0455 18.864V1.69775C18.0455 0.777476 17.2786 0 16.3335 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.33325,
    y: 5,
    width: 9.16667,
    height: 1.25,
    rx: 0.625,
    fill: "#CECECE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_7946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookMark);
export default __webpack_public_path__ + "static/media/icon-bookMark.4d9872f2f4efca33303b5b5f3f2b193d.svg";
export { ForwardRef as ReactComponent };